import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function EasterAccessory() {
  return (
    <g aria-hidden="true">
      {/* Bunny ears — tall and clear */}
      <ellipse cx="84" cy="62" rx="8" ry="26" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="1" transform="rotate(-12 84 62)" />
      <ellipse cx="84" cy="64" rx="4" ry="18" fill="#FFC0CB" transform="rotate(-12 84 64)" />
      <ellipse cx="116" cy="62" rx="8" ry="26" fill="#F9FCF1" stroke="#dde0d5" strokeWidth="1" transform="rotate(12 116 62)" />
      <ellipse cx="116" cy="64" rx="4" ry="18" fill="#FFC0CB" transform="rotate(12 116 64)" />
      {/* Blue striped egg on roof */}
      <g transform="translate(91 88) rotate(-15)">
        <ellipse cx="0" cy="0" rx="9" ry="12" fill="#2E8FA1" stroke="#F9FCF1" strokeWidth="1.5" />
        <path d="M-7,-4 L7,-4" stroke="#F9FCF1" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M-8,0 L8,0" stroke="#F9FCF1" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M-7,4 L7,4" stroke="#F9FCF1" strokeWidth="1.5" strokeLinecap="round" />
      </g>
      {/* Pink dotted egg on roof */}
      <g transform="translate(112 90) rotate(15)">
        <ellipse cx="0" cy="0" rx="9" ry="12" fill="#FFC0CB" stroke="#F9FCF1" strokeWidth="1.5" />
        <circle cx="-4" cy="-5" r="1.8" fill="#E0290A" />
        <circle cx="3" cy="-3" r="1.8" fill="#E0290A" />
        <circle cx="-3" cy="2" r="1.8" fill="#E0290A" />
        <circle cx="4" cy="5" r="1.8" fill="#E0290A" />
        <circle cx="-2" cy="7" r="1.8" fill="#E0290A" />
      </g>
      {/* Yellow egg with zigzag beside Turbo */}
      <g transform="translate(168 100) rotate(25)">
        <ellipse cx="0" cy="0" rx="8" ry="11" fill="#E5B941" stroke="#F9FCF1" strokeWidth="1.5" />
        <path d="M-5,-3 L-2,-5 L1,-3 L4,-5 L5,-3" stroke="#E0290A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <path d="M-5,1 L-2,-1 L1,1 L4,-1 L5,1" stroke="#E0290A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        <path d="M-5,5 L-2,3 L1,5 L4,3 L5,5" stroke="#E0290A" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      </g>
    </g>
  );
}
